export default __webpack_public_path__ + "static/media/Delete this Number.1db2aa3d.svg";